import { useEffect, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Hero3D from "./components/Hero3D";
import LiquidCursor from "./components/LiquidCursor";
import React from "react";
import { LanguageProvider } from "./contexts/language";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { HelmetProvider } from 'react-helmet-async';

// Lazy load components below the fold
const ProductSection = lazy(() => import("./components/ProductSection"));
const CardDeck = lazy(() => import("./components/CardDeck"));
const CustomerLogos = lazy(() => import("./components/CustomerLogos"));

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoadingFallback = () => (
  <div className="w-full h-96 flex items-center justify-center bg-orange-50">
    <div className="w-12 h-12 border-4 border-orange-200 border-t-orange-500 rounded-full animate-spin"></div>
  </div>
);

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <LiquidCursor />
      <Hero3D />
      <Suspense fallback={<LoadingFallback />}>
        <ProductSection />
        <CardDeck />
        <CustomerLogos />
      </Suspense>
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />}>
                <Route index element={<Home />} />
              </Route>
            </Routes>
            <Footer />
            <ScrollToTop />
          </BrowserRouter >
        </div >
      </LanguageProvider >
    </HelmetProvider>
  );
}

export default App;